"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerFactoryFromJS = exports.TriggerFactory = void 0;
const core_1 = require("@bimser/core");
const immutable_1 = require("immutable");
exports.TriggerFactory = (0, immutable_1.Record)({
    id: (0, core_1.createGuid)(),
    name: (0, immutable_1.Map)(),
    description: (0, immutable_1.Map)(),
    startAt: '',
    endAt: '',
    calendarId: ''
});
const TriggerFactoryFromJS = function (data) {
    return (0, exports.TriggerFactory)({
        id: data.id,
        name: (0, immutable_1.Map)(data.name),
        description: (0, immutable_1.Map)(data.description),
        calendarId: data.calendarId,
        endAt: data.endAt,
        startAt: data.startAt
    });
};
exports.TriggerFactoryFromJS = TriggerFactoryFromJS;
//# sourceMappingURL=ITrigger.js.map